import forms from "./forms";

const {
  formField: { observacao },
} = forms;

const initialValuesCortesia = {
  [observacao.name]: "",
};

export { initialValuesCortesia };
